import { TFormalOffers } from './formalOffers.types';

/**
 * Gets the maximum cash available from all formal offers
 *
 * @param formalOffers An array of formal offers.
 * @returns The highest available cash amount from all formal offers in a list.
 */
export const getFormalOffersMaxAvailableCash = (
    formal_offers: TFormalOffers
) => {
    return Math.floor(
        formal_offers.reduce<number>((max, offer) => {
            const maxFromOffer = offer.available_cash!;
            return maxFromOffer > max ? maxFromOffer : max;
        }, 0)
    );
};
